import { buildGroupsByCategory } from "./risk-groups";

export type MerchantRiskRow = {
  riskId: string;
  risk: {
    readableName: string;
    category: string;
  };
};

export type RiskFilterItem = { key: string; name: string; category: string; riskIds: string[] };
export type RiskFilterGroup = { id: string; name: string; items: RiskFilterItem[] };

export function buildMerchantRiskFilterGroups(rows: MerchantRiskRow[]): RiskFilterGroup[] {
  return buildGroupsByCategory<MerchantRiskRow, RiskFilterItem>(
    rows,
    (row) => row.risk.readableName,
    (row) => row.risk.category,
    (row) => ({
      key: row.riskId,
      name: row.risk.readableName,
      category: row.risk.category,
      riskIds: [row.riskId],
    }),
    (existing, row) => existing.riskIds.push(row.riskId),
  );
}
